var stripeScript
export default {
  methods: {
    loadStripeScript (publicKey, success = () => {}) {
      // console.log(publicKey)
      if (!stripeScript) {
        stripeScript = window.document.createElement('script')
        stripeScript.src = 'https://js.stripe.com/v3/'
        stripeScript.onload = () => {
          console.log('loadStripeScript成功===========')
          window.stripe = Stripe(publicKey)
          window.stripeElements = window.stripe.elements()
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(stripeScript, head.firstChild)
      } else {
        console.log('Stripe已加载')
        window.stripe = Stripe(publicKey)
        window.stripeElements = window.stripe.elements()
        success && success()
      }
    },
    //  创建Stripe支付
    createStripePayment(data, success = () => { }) {
      this._clientSecret = data.clientSecret
      if (window.stripe) {
        this.clientSecret = data
        const layout = { layout: "tabs" }
        const options = {
          clientSecret: data.clientSecret,
          appearance: { theme: "stripe" }
        }
        const payMode = this.payMode.toLocaleUpperCase();
        const isFastPayment = payMode.includes("APPLE") || payMode.includes("GOOGLE")
        if (isFastPayment) {
          layout.paymentMethodOrder = ['apple_pay', 'google_pay', 'card']
        }
        this.creditcard = window.stripe.elements(options)
        console.log("createStripePayment ~ options:", options, '--layout:', layout)
        const paymentElement = this.creditcard.create("payment", layout)
        this.isCreditcard = true
        paymentElement.mount("#credit-card-element")
      } else {
        this.$toast("loading...")
      }
    },
    onLoadElement() {
      const options = {
        clientSecret: this.creditOrder.clientSecret,
        appearance: { theme: "stripe" }
      }
      if (window.stripe) {
        // this.loadStripeScript(this.payMode.publicKey)
        this.creditcard = window.stripe.elements(options)
        const paymentElement = this.creditcard.create("payment")
        // this.payListShow = false
        paymentElement.mount("#credit-card-element")
      } else {
        this.$toast("loading...")
        this.loadStripeScript()
        setTimeout(() => {
          this.onLoadElement()
        }, 500)
      }
    }
  }
}
